/**
 * 各ブランドの各店舗の地図スライダー
 */

import { showSlide } from '../function/showSlide';
import { updateActiveListItem } from '../function/updateActiveListItems';

// urlからクエリパラメータを取得する関数
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

export default class RestaurantDetailSlider {
  constructor(_param) {
    // 店舗リストを取得
    this.listItems = document.querySelectorAll(_param.locationName);
    // 店舗名をdatasetで使えるように加工
    this.locationName = _param.locationName.toLowerCase().replace('data-', '').replace('[', '').replace(']', '');
    // タイストリートフードページか判別(スライドのループ形式変更)
    const sliderType = location.href.includes('thaistreetfood') ? 'slide' : 'loop';

    this.splide = new Splide('#shop-splide', {
      arrows: false,
      gap: '60px',
      pagination: false,
      trimSpace: false,
      focus: 'center',
      type: sliderType,
      breakpoints: {
        768: {
          gap: '20px',
        },
      },
    }).mount();

    // スライダーの移動イベントにリスナーを追加
    // newIndexは自動で渡ってくる
    this.splide.on('move', (newIndex) => {
      updateActiveListItem(newIndex, this.listItems);
    });

    // ページ読み込み時に実行させたいためここで実行
    this.initSlideBasedOnURLParam();
  }

  /**
   * クリックされた店舗に対応するスライドに遷移
   */
  initSlideBasedOnURLParam() {
    // パラメータを取得
    const shopParam = getQueryParam('shop');
    if (shopParam) {
      // パラメータとリストのdata属性の値が一致するindexを返す
      // listItemsはNodeListオブジェクトでありfindIndexに対応していないため配列に変換
      const index = Array.from(this.listItems).findIndex((item) => item.dataset[this.locationName] === shopParam);
      if (index >= 0) {
        showSlide(index, this.listItems, this.splide);
      }
    }
  }

  /**
   * イベントを追加
   */
  addEvent() {
    this.listItems.forEach((item, index) => {
      item.addEventListener('click', (ev) => {
        ev.preventDefault();
        showSlide(index, this.listItems, this.splide);
      });
    });
  }

  init() {
    if (this.listItems.length === 0) return;
    this.addEvent();
  }
}
